import { render, staticRenderFns } from "./CxFocusKpiItem.vue?vue&type=template&id=a09e89a8&scoped=true&"
import script from "./CxFocusKpiItem.vue?vue&type=script&lang=js&"
export * from "./CxFocusKpiItem.vue?vue&type=script&lang=js&"
import style0 from "./CxFocusKpiItem.vue?vue&type=style&index=0&id=a09e89a8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a09e89a8",
  null
  
)

export default component.exports